/**
 * List of supported players and components used for imports
 */
// TODO: figure out a way to add an object to the array with a node script

import { lazy } from "preact/compat";

const config = [
  {
    key: "native",
    player: lazy(() => import("./FilePlayer")),
  },
  {
    key: "YouTube",
    player: lazy(() => import("./Youtube")),
  },
  {
    key: "Brightcove",
    player: lazy(() => import("./Brightcove/Brightcove")),
  },
  {
    key: "Kaltura",
    player: lazy(() => import("./Kaltura/Kaltura")),
  },
  {
    key: "Wistia",
    player: lazy(() => import("./Wistia/Wistia")),
  },
];

export default config;
